// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XRmh","col":"styles_col__KWtXZ"};